import { useState, useEffect } from "react";
import { HashRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from "./redux/Store";
import { Toaster } from "react-hot-toast";
import ProtectedRoute from "./components/ProtectedRoute";
import IntroSplash from "./components/IntroSplash";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BottomNavbar from "./components/BottomNavbar";
import Signup from "./components/Signup";
import Login from "./components/Login";
import SimpleCards from "./components/SimpleCards";
import ViewCart from './Orders/ViewCart';
import Wishlist from "./Orders/Wishlist";
import Checkout from './Orders/Checkout';
import UserProfile from './pages/UserProfile'
import Forgot from './pages/Forgot'
import OrderHistory from './Orders/OrderHistory'
import OrderTracking from './Orders/OrderTracking'
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ShippingPolicy from "./pages/ShippingPolicy";
import CancellationRefundsPolicy from "./pages/CancellationRefundsPolicy";
// import PromoModal from "./components/PromoModal";

import ResetPassword from "./components/ResetPassword"
import ErrorBoundary from "./components/ErrorBoundary";
import { fetchUserWishlist } from "./redux/WishlistSlice";
import { fetchUserCart } from "./redux/cartSlice";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const [searchQuery, setSearchQuery] = useState("");
  const [showSplash, setShowSplash] = useState(() => {
    // splash was shown in session
    const splashShown = sessionStorage.getItem('splashShown');
    return !splashShown; 
  });

  // Make store available globally for logout
  window.store = store;

  const handleSplashComplete = () => {
    sessionStorage.setItem('splashShown', 'true');
    setShowSplash(false);
  };

  useEffect(() => {
    // Initialize AOS
    if (typeof window !== 'undefined') {
      import('aos').then((AOS) => {
        AOS.init({
          duration: 800,
          easing: 'ease-in-out',
          once: false,
          offset: 100,
          delay: 100,
          anchorPlacement: 'top-bottom',
        });
      });
    }

    // Refresh AOS when route changes
    const timer = setTimeout(() => {
      if (typeof window !== 'undefined') {
        import('aos').then((AOS) => {
          AOS.refresh();
        });
      }
    }, 100);

// Fetch user wishlist and cart if token in 
    const token = localStorage.getItem('token');
    if (token) {
      store.dispatch(fetchUserWishlist());
      store.dispatch(fetchUserCart());
    }

    return () => clearTimeout(timer);
  }, []);

  return (
    <ErrorBoundary>
      {showSplash && <IntroSplash onComplete={handleSplashComplete} />}
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <ScrollToTop />
            <div className="App">
              <Navbar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
              <Routes>
              <Route path="/" element={<Home searchQuery={searchQuery} />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/about" element={<About />} />
              <Route path="/login" element={<Login />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/products" element={<SimpleCards searchQuery={searchQuery} />} />
              <Route path="/cart" element={<ViewCart />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
              <Route path="/forget" element={<Forgot />} />
              <Route path="/orderhistory" element={<ProtectedRoute><OrderHistory /></ProtectedRoute>} />
              <Route path="/ordertracking/:orderId" element={<ProtectedRoute><OrderTracking /></ProtectedRoute>} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/shipping-policy" element={<ShippingPolicy />} />
              <Route path="/cancellation-refunds" element={<CancellationRefundsPolicy />} />
            </Routes>
            <Footer />
            <BottomNavbar />
            <Toaster position="top-center" />
          </div>
        </Router>
      </PersistGate>
    </Provider>
    </ErrorBoundary>
  );
}

export default App;